const selector = {
    btnViewTransactions: '.js-view-transactions',
    modalTransactions: '#modal_transactions',
    transactionsLoader: '#transactions_loader',
    transactionsContent: '#transactions_content',
    transactionsEmpty: '#transactions_empty',
    transactionsError: '#transactions_error',
};

export { selector };
